// AMR study — reuses the originally authored instrument (pre→educate→post).
import { demographics, knowledge, attitude, selfEfficacy, practice } from '../data/questionnaire';
import { educationModules } from '../data/education';

export default {
  slug: 'amr',
  code: 'KS01',
  title: 'Effect of a Structured Educational Intervention on the Knowledge, Attitude, and Practice of Antimicrobial Resistance and Rational Antibiotic Prescribing Among Dental Students and Interns: A Pre–Post Interventional Study',
  shortTitle: 'AMR & Antibiotic Prescribing',
  studyTitle: 'Knowledge, Attitude & Practice on Antimicrobial Resistance',
  topic: 'Antimicrobial stewardship',
  emoji: '💊',
  accent: '#22E3C3',
  estMinutes: 12,
  mode: 'pre-post',
  status: 'live',
  version: '2.0',
  practiceMax: 6, // scored practice items (V1–V6); keep in sync with keys.ts (drift-tested)
  blurb: 'Antibiotic-prescribing knowledge, attitudes and practice — with a built-in learning module that measures what changes.',
  sections: { demographics, knowledge, attitude, selfEfficacy, practice },
  education: educationModules,
  educationTitle: 'Antibiotics in dentistry: the essentials',
  educationBlurb: 'A two-minute refresher based on current guidelines (ADA 2019, AHA 2021). Read through, then continue to the short follow-up.',
};
